import { Link } from 'react-router-dom';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import { useOrgOnboardingGate } from 'src/features/organization/hooks/useOrgOnboardingGate';
import CalendlyOnboardingScreen from 'src/features/organization/ui/CalendlyOnboardingScreen';
import { ROUTE_PATHS } from 'src/shared/config/routes';
import { usePageTitle } from 'src/shared/hooks';

import { ButtonV2, Spinner } from 'src/shared/components/ui';

const OnboardingDiscoveryPage = () => {
  usePageTitle('Book a Discovery Call | Cavela');
  const user = useAuthStore((state) => state.user);
  const { data: onboardingGate, isLoading } = useOrgOnboardingGate(true);

  if (isLoading || !onboardingGate?.discovery_calendly_url) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="min-h-dvh overflow-y-auto bg-white">
      <CalendlyOnboardingScreen
        calendlyUrl={onboardingGate.discovery_calendly_url}
        userName={user?.username ?? ''}
        headerAction={
          <ButtonV2
            as={Link}
            to={ROUTE_PATHS.BUILD_ANYTHING}
            href={ROUTE_PATHS.BUILD_ANYTHING}
            color="tertiary"
          >
            I want to make an RFQ before booking
          </ButtonV2>
        }
      />
    </div>
  );
};

export default OnboardingDiscoveryPage;
